import { STARTUP_CHECK_TIMEOUT_MS } from "./startupTimings";
/** Begrenztes Warten auf lesende Startprüfungen; späte Ergebnisse werden verworfen. */
export function runStartupTask<T>(operation: (signal: AbortSignal) => Promise<T>, signal: AbortSignal): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    if (signal.aborted) { reject(signal.reason); return; }
    const controller = new AbortController();
    const forwardAbort = () => controller.abort(signal.reason);
    const timer = setTimeout(() => controller.abort(new DOMException("Startup check timed out", "TimeoutError")), STARTUP_CHECK_TIMEOUT_MS);
    const cleanup = () => { clearTimeout(timer); signal.removeEventListener("abort", forwardAbort); };
    controller.signal.addEventListener("abort", () => { cleanup(); reject(controller.signal.reason); }, { once: true });
    signal.addEventListener("abort", forwardAbort, { once: true });
    let task: Promise<T>;
    try { task = operation(controller.signal); } catch (error) { cleanup(); reject(error); return; }
    task.then(
      value => { cleanup(); if (!controller.signal.aborted) resolve(value); },
      error => { cleanup(); reject(error); },
    );
  });
}
